'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { type Tracker } from '@qogita/tracking'
import { createContext, useContext } from 'react'

import { SellersBrowserTrackingEventList } from './types'

export const BrowserTrackerContext =
  createContext<Tracker<SellersBrowserTrackingEventList> | null>(null)

export function useBrowserTracker() {
  const tracker = useContext(BrowserTrackerContext)
  if (!tracker) {
    throw new Error(
      'useBrowserTracker must be used within a BrowserTrackerProvider',
    )
  }
  return tracker
}
